import { Outlet, createFileRoute } from "@tanstack/react-router";
import { HeartHand } from "@untitled-ui/icons-react";

import TableSkeleton from "@/components/loadings/skeleton/TableSkeleton";
import type { ChildRouteContext } from "@/root";
import { redirectIfModuleDisabled } from "@/utils/permissions";

export const Route = createFileRoute("/_panel/_recognition")({
  component: Component,
  beforeLoad: ({ context }) => {
    redirectIfModuleDisabled("recognition", context.tenant.modules);

    return {
      title: () => context.t("Recognition", { ns: "recognition.shared" }),
      crumb: [
        {
          Icon: HeartHand,
        },
        {
          label: context.t("Recognition", { ns: "recognition.shared" }),
          link: { to: "/recognition" },
        },
      ],
    } satisfies ChildRouteContext;
  },
  pendingComponent: TableSkeleton,
});

function Component() {
  return <Outlet />;
}
